import { MessageService } from './../../../../../shared/message/message.service';
import { CnpjService } from './../../cnpj.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { map, of } from 'rxjs';
import { CompanySetupService } from '../../company-setup.service';

@Component({
  selector: 'app-company-setup-info',
  templateUrl: './company-setup-info.component.html',
  styleUrls: ['./company-setup-info.component.scss'],
})
export class CompanySetupInfoComponent implements OnInit {
  infoForm: FormGroup = this.companySetupService.infoForm;

  companyTypes$ = this.companySetupService.getCompanyTypes();
  companySectors$ = this.companySetupService.getCompanySectors().pipe(
    map((sectors) =>
      sectors.reduce((acc, sector) => {
        if (sector.sectors.length === 0)
          return (acc = [...acc, { ...sector, group: sector.description }]);
        return (acc = [
          ...acc,
          ...sector.sectors.map((childSector) => ({
            ...childSector,
            group: sector.description,
          })),
        ]);
      }, [])
    )
  );

  constructor(private companySetupService: CompanySetupService, private messageService: MessageService, private cnpjService : CnpjService) {}

  ngOnInit(): void {}

  get controls(): any {
    return this.infoForm.controls;
  }

  get secondaryActivities() {
    return this.companySetupService.secondaryActivities;
  }

  onChangeCnpj(){
    const cnpj = this.infoForm.get('cnpj')?.value;
    if(cnpj){
      this.cnpjService.getCnpjInfo(cnpj).subscribe({
        next : (res : any) => {
            if(res){
              this.infoForm.get('name')?.setValue(res?.nome)
              this.infoForm.get('fantasyName')?.setValue(res?.fantasia)
              this.infoForm.get('activity')?.setValue(res?.atividade_principal[0]?.code + ' - ' +  res?.atividade_principal[0]?.text)
              this.companySetupService.secondaryActivities = (res?.atividades_secundarias || []).map((a: any) => ({ code: a.code, text: a?.code + ' - ' + a?.text }))
              this.getType(res?.natureza_juridica);
            }
        }, error: (error : any) => {
          if (error.error.code === 'ME017') {
            this.messageService.addMsgWarning({
              message: error.error.message,
              autoclose: true,
            })
            this.infoForm.get('cnpj').reset();
          } else {
            this.messageService.addMsgInfo({
              message: 'CNPJ não localizado, inclua manualmente as informações!',
              autoclose: true,
            });
          }

        }
      })
    }
  }

  getType(type: any) {
  const sigla = type.split(' - ')[0];

  this.companyTypes$.subscribe((types: any[]) => {
    const companyType = types.find(i => i.sigla === sigla);

    console.log(companyType);

    this.infoForm.get('type')?.setValue(companyType);
  });
}
}
